/* R&D Industries — custom gasket quoter (storefront). Needs gasket-core.js. */
(function () {
  'use strict';
  var root = document.getElementById('GasketQuoter');
  if (!root || !window.RDGasketCore) return;
  var C = window.RDGasketCore;
  var cfgEl = root.querySelector('[data-gq-config]');
  var config;
  try { config = JSON.parse(cfgEl.textContent); } catch (e) {
    root.querySelector('[data-gq-errors]').hidden = false;
    root.querySelector('[data-gq-errors]').innerHTML = '<li>Pricing is not set up correctly (gasket-pricing.liquid is not valid JSON).</li>';
    return;
  }
  var $ = function (sel) { return root.querySelector(sel); };
  var endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '');
  var shopRoot = root.dataset.root || '/';
  if (shopRoot.slice(-1) !== '/') shopRoot += '/';

  var MM = C.MM_PER_IN;
  var DEFAULTS = {
    flange: { od: 6, id: 2.375, bc: 4.75, holes: 4, hole_d: 0.75 },
    ring: { od: 4, id: 2.5 },
    disc: { od: 4 },
    rect: { w: 6, l: 4, r: 0.25, holes: 0, hole_d: 0.375, e: 0.5 },
    frame: { w: 8, l: 6, r: 0.5, iw: 6, il: 4, ir: 0.25, holes: 0, hole_d: 0.25, e: 0.5 }
  };
  var HINTS = {
    od: 'Across the widest point', id: 'The bore / center opening', bc: 'Center-to-center of opposite holes',
    holes: 'Count of bolt holes', hole_d: 'Bolt size + about 1/16"', w: 'Outside width', l: 'Outside length',
    r: '0 for square corners', iw: 'Centered cut-out', il: 'Centered cut-out', ir: '0 for square corners',
    e: 'Outside edge to hole centers'
  };
  var RECT_HINTS = { holes: '0 = no holes · 2 (one each end) · or an even number, 4 or more', hole_d: 'Bolt size + about 1/16"' };
  var ROUND = { flange: 1, ring: 1, disc: 1 };
  function isRectShape(sh) { return sh === 'rect' || sh === 'frame'; }
  function rectHolesOff() { return isRectShape(state.shape) && !(C.num(state.dims.holes) > 0); }
  var SHAPE_ICONS = {
    flange: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="20" cy="20" r="17"/><circle cx="20" cy="20" r="8"/><circle cx="20" cy="7.5" r="1.8"/><circle cx="20" cy="32.5" r="1.8"/><circle cx="7.5" cy="20" r="1.8"/><circle cx="32.5" cy="20" r="1.8"/></svg>',
    ring: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="20" cy="20" r="17"/><circle cx="20" cy="20" r="10"/></svg>',
    disc: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="20" cy="20" r="17" fill="currentColor" fill-opacity=".18"/></svg>',
    rect: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="9" width="32" height="22" rx="3" fill="currentColor" fill-opacity=".18"/></svg>',
    frame: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="8" width="32" height="24" rx="3"/><rect x="10" y="14" width="20" height="12" rx="1.5"/></svg>'
  };
  var SHAPE_SHORT = { flange: 'Flange', ring: 'Ring', disc: 'Disc', rect: 'Rectangle', frame: 'Frame' };
  var FILL = { Black: '#3A414C', Red: '#B5523B', Tan: '#B89A6A', White: '#D9DDE3', Blue: '#4F7BB5', Green: '#5C8F4E' };

  // ---------- state ----------
  var state = {
    shape: root.dataset.defaultShape || 'flange',
    units: 'in',
    dims: {},
    material: root.dataset.defaultMaterial || (config.materials[0] && config.materials[0].id),
    thickness: null,
    qty: '1',
    psa: false,
    notes: ''
  };
  var lastQuote = null;

  function fmtNum(x, units) {
    if (!isFinite(x)) return '';
    var p = units === 'mm' ? 100 : 10000;
    return String(Math.round(x * p) / p);
  }
  function loadDefaults(shape) {
    var d = DEFAULTS[shape], out = {};
    for (var k in d) out[k] = (k === 'holes') ? String(d[k]) : fmtNum(state.units === 'mm' ? d[k] * MM : d[k], state.units);
    return out;
  }
  function pickThickness(mat, prefer) {
    if (!mat) return null;
    var ids = mat.thicknesses.map(function (t) { return t.id; });
    if (prefer && ids.indexOf(prefer) > -1) return prefer;
    if (ids.indexOf('1-8') > -1) return '1-8';
    return ids[0];
  }
  function encodeState() {
    var s = JSON.stringify({ s: state.shape, u: state.units, d: state.dims, m: state.material, t: state.thickness, q: state.qty, p: state.psa ? 1 : 0 });
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeState(str) {
    try {
      str = str.replace(/-/g, '+').replace(/_/g, '/');
      var o = JSON.parse(decodeURIComponent(escape(atob(str))));
      if (!C.SHAPES[o.s]) return false;
      state.shape = o.s; state.units = o.u === 'mm' ? 'mm' : 'in';
      state.dims = o.d || {}; state.material = o.m; state.thickness = o.t;
      state.qty = String(o.q || 1); state.psa = !!o.p;
      return true;
    } catch (e) { return false; }
  }
  function store() {
    var code = encodeState();
    try { history.replaceState(null, '', location.pathname + location.search.replace(/[?&]contact_posted=true/, '') + '#q=' + code); } catch (e) {}
    try { sessionStorage.setItem('rd-gq', code); } catch (e) {}
  }

  // ---------- rendering: inputs ----------
  function renderShapes() {
    var box = $('[data-gq-shapes]');
    box.innerHTML = Object.keys(C.SHAPES).map(function (k) {
      return '<button type="button" class="gq-shape" data-shape="' + k + '" aria-pressed="' + (k === state.shape) + '">' + SHAPE_ICONS[k] + '<span>' + SHAPE_SHORT[k] + '</span></button>';
    }).join('');
  }
  function renderUnits() {
    root.querySelectorAll('[data-gq-units] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.unit === state.units)); });
  }
  function renderFields() {
    var fields = C.SHAPES[state.shape].fields;
    $('[data-gq-fields]').innerHTML = fields.map(function (k) {
      var isCount = k === 'holes';
      var v = state.dims[k] !== undefined ? state.dims[k] : '';
      var hint = (isRectShape(state.shape) && RECT_HINTS[k]) || HINTS[k];
      var dep = isRectShape(state.shape) && (k === 'hole_d' || k === 'e');
      return '<div class="gq-field" data-field="' + k + '"' + (dep && rectHolesOff() ? ' hidden' : '') + '><label for="gq-f-' + k + '">' + C.FIELD_LABELS[k] + '</label>' +
        '<div class="gq-input"><input id="gq-f-' + k + '" data-dim="' + k + '" type="text" inputmode="' + (isCount ? 'numeric' : 'decimal') + '" autocomplete="off" value="' + String(v).replace(/"/g, '&quot;') + '">' +
        (isCount ? '' : '<span class="u">' + state.units + '</span>') + '</div>' +
        '<div class="hint">' + hint + (isCount ? '' : (state.units === 'in' ? ' · fractions OK' : '')) + '</div></div>';
    }).join('');
  }
  function renderMaterials() {
    var sel = $('[data-gq-material]');
    sel.innerHTML = config.materials.map(function (m) {
      return '<option value="' + m.id + '"' + (m.id === state.material ? ' selected' : '') + '>' + m.name + '</option>';
    }).join('');
    if (!C.findMaterial(config, state.material)) { state.material = config.materials[0].id; sel.value = state.material; }
  }
  function renderMaterialDetail() {
    var m = C.findMaterial(config, state.material);
    state.thickness = pickThickness(m, state.thickness);
    var chips = [];
    if (m.best_for) chips.push(m.best_for);
    if (m.temp) chips.push(m.temp);
    if (m.durometer && m.durometer !== '—') chips.push(m.durometer + ' durometer');
    if (m.color) chips.push(m.color);
    $('[data-gq-matinfo]').innerHTML = chips.map(function (c) { return '<span>' + c + '</span>'; }).join('');
    $('[data-gq-thick]').innerHTML = m.thicknesses.map(function (t) {
      return '<button type="button" data-thick="' + t.id + '" aria-pressed="' + (t.id === state.thickness) + '">' + t.label + '</button>';
    }).join('');
  }
  function renderTiers(qty) {
    var br = (config.qty_breaks || []).slice().sort(function (a, b) { return a.min - b.min; });
    var cur = C.tierFor(config, qty || 1).current;
    $('[data-gq-tiers]').innerHTML = br.length > 1 ? br.map(function (b) {
      var pct = Math.round((1 - b.multiplier) * 100);
      return '<span class="' + (b === cur ? 'on' : '') + '">' + b.min + '+ ' + (pct > 0 ? '−' + pct + '%' : 'list') + '</span>';
    }).join('') : '';
  }
  function renderPsa() {
    var wrap = $('[data-gq-psa-wrap]');
    if (config.psa && config.psa.enabled) {
      wrap.hidden = false;
      $('[data-gq-psa-label]').textContent = config.psa.label || 'Adhesive backing';
      $('[data-gq-psa]').checked = state.psa;
    } else { wrap.hidden = true; state.psa = false; }
  }

  // ---------- rendering: drawing ----------
  function circ(cx, cy, r) {
    return 'M' + (cx - r) + ' ' + cy + 'a' + r + ' ' + r + ' 0 1 0 ' + (2 * r) + ' 0a' + r + ' ' + r + ' 0 1 0 ' + (-2 * r) + ' 0Z';
  }
  function rrect(x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    if (r === 0) return 'M' + x + ' ' + y + 'h' + w + 'v' + h + 'h' + (-w) + 'Z';
    return 'M' + (x + r) + ' ' + y + 'h' + (w - 2 * r) + 'a' + r + ' ' + r + ' 0 0 1 ' + r + ' ' + r + 'v' + (h - 2 * r) +
      'a' + r + ' ' + r + ' 0 0 1 ' + (-r) + ' ' + r + 'h' + (-(w - 2 * r)) + 'a' + r + ' ' + r + ' 0 0 1 ' + (-r) + ' ' + (-r) +
      'v' + (-(h - 2 * r)) + 'a' + r + ' ' + r + ' 0 0 1 ' + r + ' ' + (-r) + 'Z';
  }
  function dimH(x1, x2, y, label, above) {
    var ty = above ? y - 8 : y + 16;
    return '<g class="dim"><line x1="' + x1 + '" y1="' + y + '" x2="' + x2 + '" y2="' + y + '"/>' +
      '<path d="M' + x1 + ' ' + y + 'l7 -3.5v7Z M' + x2 + ' ' + y + 'l-7 -3.5v7Z" class="ah"/>' +
      '<text x="' + ((x1 + x2) / 2) + '" y="' + ty + '" text-anchor="middle">' + label + '</text></g>';
  }
  function dimV(x, y1, y2, label) {
    var my = (y1 + y2) / 2;
    return '<g class="dim"><line x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '"/>' +
      '<path d="M' + x + ' ' + y1 + 'l-3.5 7h7Z M' + x + ' ' + y2 + 'l-3.5 -7h7Z" class="ah"/>' +
      '<text x="' + (x + 14) + '" y="' + my + '" text-anchor="middle" transform="rotate(90 ' + (x + 14) + ' ' + my + ')">' + label + '</text></g>';
  }
  function drawSvg(q) {
    var d = q.dimsIn, g = q.geometry, u = q.units, L = function (v) { return C.fmtLen(v, u); };
    var mat = C.findMaterial(config, state.material) || {};
    var fill = FILL[mat.color] || '#3A414C';
    var S = 400, M = 58, span = S - 2 * M;
    var sc = span / Math.max(g.bboxW, g.bboxL);
    var cx = S / 2, cy = S / 2 - 6;
    var body = '', dims = '';
    if (q.shape === 'flange' || q.shape === 'ring' || q.shape === 'disc') {
      var R = d.od / 2 * sc, r = (q.shape === 'disc' ? 0 : (d.id || 0)) / 2 * sc;
      var p = circ(cx, cy, R);
      if (r > 0) p += circ(cx, cy, r);
      if (q.shape === 'flange') {
        var n = Math.round(d.holes), bcr = d.bc / 2 * sc, hr = Math.max(d.hole_d / 2 * sc, 0.6);
        for (var i = 0; i < n; i++) {
          var a = -Math.PI / 2 + (Math.PI / n) + i * 2 * Math.PI / n;
          if (n % 2 === 1) a = -Math.PI / 2 + i * 2 * Math.PI / n;
          p += circ(cx + bcr * Math.cos(a), cy + bcr * Math.sin(a), hr);
        }
        body += '<circle cx="' + cx + '" cy="' + cy + '" r="' + bcr + '" class="bc"/>';
        var ha = n % 2 === 1 ? -Math.PI / 2 : -Math.PI / 2 + Math.PI / n;
        var hx = cx + bcr * Math.cos(ha), hy = cy + bcr * Math.sin(ha);
        dims += '<g class="dim"><line x1="' + (hx + hr * 0.7) + '" y1="' + (hy - hr * 0.7) + '" x2="' + (S - 34) + '" y2="' + 40 + '"/><text x="' + (S - 30) + '" y="54" text-anchor="end">' + n + '× Ø' + L(d.hole_d) + '</text></g>';
        dims += '<text class="lbl" x="' + 22 + '" y="' + 54 + '">BC Ø' + L(d.bc) + '</text>';
      }
      body = '<path d="' + p + '" fill-rule="evenodd" fill="' + fill + '" class="part"/>' + body;
      dims += dimH(cx - R, cx + R, cy + R + 22, 'Ø' + L(d.od) + ' OD', false);
      if (r > 0) dims += dimH(cx - r, cx + r, cy, 'Ø' + L(d.id) + ' ID', true);
    } else {
      var W = d.w * sc, H = d.l * sc, x = cx - W / 2, y = cy - H / 2;
      var p2 = rrect(x, y, W, H, (d.r || 0) * sc);
      if (q.shape === 'frame') {
        var iW = d.iw * sc, iH = d.il * sc;
        p2 += rrect(cx - iW / 2, cy - iH / 2, iW, iH, (d.ir || 0) * sc);
        dims += dimH(cx - iW / 2, cx + iW / 2, cy - iH / 2 + 22, L(d.iw), false);
        dims += dimV(cx + iW / 2 - 34, cy - iH / 2, cy + iH / 2, L(d.il));
      }
      var rh = C.rectHoles(d);
      if (rh.length) {
        var rr = Math.max(d.hole_d / 2 * sc, 0.6);
        rh.forEach(function (pt) { p2 += circ(cx + pt.x * sc, cy + pt.y * sc, rr); });
        dims += '<text class="lbl" x="22" y="34">' + rh.length + '× Ø' + L(d.hole_d) + ' · ' + L(d.e) + ' from edge</text>';
      }
      body = '<path d="' + p2 + '" fill-rule="evenodd" fill="' + fill + '" class="part"/>';
      dims += dimH(x, x + W, y + H + 22, L(d.w), false);
      dims += dimV(x + W + 18, y, y + H, L(d.l));
    }
    return '<svg viewBox="0 0 ' + S + ' ' + S + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Drawing of the gasket">' +
      '<style>.part{fill-opacity:.55;stroke:#93C982;stroke-width:1.4}.bc{fill:none;stroke:#6B7585;stroke-dasharray:3 5}.dim line{stroke:#A6B0BF;stroke-width:1}.dim .ah{fill:#A6B0BF}.dim text,.lbl{fill:#EEF2F7;font:500 12px "JetBrains Mono",ui-monospace,monospace}.dim text{paint-order:stroke;stroke:#0E1520;stroke-width:4px;stroke-linejoin:round}.grid{stroke:#1F2735;stroke-width:1;opacity:.6}</style>' +
      '<g class="grid"><path d="M0 80H400M0 160H400M0 240H400M0 320H400M80 0V400M160 0V400M240 0V400M320 0V400"/></g>' +
      body + dims + '</svg>';
  }

  // ---------- quote + output ----------
  function currentSpec() {
    return { shape: state.shape, units: state.units, dims: state.dims, material: state.material, thickness: state.thickness, qty: state.qty, psa: state.psa };
  }
  function setText(sel, txt) { var el = $(sel); if (el) el.textContent = txt; }

  function update() {
    var spec = currentSpec();
    var q = C.quote(spec, config);
    lastQuote = q;
    var money = function (x) { return C.money(x, config); };

    // field-level invalid marks
    root.querySelectorAll('[data-dim]').forEach(function (inp) {
      var v = C.num(inp.value);
      var optionalZero = inp.dataset.dim === 'r' || inp.dataset.dim === 'ir' || (inp.dataset.dim === 'id' && state.shape === 'flange') || (inp.dataset.dim === 'holes' && isRectShape(state.shape));
      inp.setAttribute('aria-invalid', String(inp.value.trim() !== '' && (isNaN(v) || v < 0 || (v === 0 && !optionalZero))));
    });

    // drawing
    var draw = $('[data-gq-draw]');
    var old = draw.querySelector('svg, .empty'); if (old) old.remove();
    setText('[data-gq-draw-label]', SHAPE_SHORT[state.shape].toUpperCase());
    var geomOk = q.geometry && q.dimsIn && C.validate(state.shape, q.dimsIn, config, state.units).length === 0;
    if (geomOk) draw.insertAdjacentHTML('beforeend', drawSvg(q));
    else draw.insertAdjacentHTML('beforeend', '<div class="empty">Enter valid dimensions to see your gasket.</div>');

    renderTiers(C.num(state.qty));

    var errs = $('[data-gq-errors]');
    if (q.ok) {
      setText('[data-gq-total]', money(q.lineTotal));
      setText('[data-gq-each]', money(q.unitPrice) + ' × ' + q.qty);
      setText('[data-gq-mtotal]', money(q.lineTotal));
      setText('[data-gq-meach]', money(q.unitPrice) + ' each · ' + q.qty + ' pc');
      errs.hidden = true; errs.innerHTML = '';
      var save = $('[data-gq-save]');
      if (q.nextBreak) { save.hidden = false; save.textContent = 'Order ' + q.nextBreak.min + '+ and pay ' + money(q.nextBreak.unitPrice) + ' each (save ' + q.nextBreak.savePct + '%).'; }
      else save.hidden = true;
      var rows = q.summary.slice(1).map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; });
      var areaLbl = (config.pricing && config.pricing.area_basis === 'net') ? 'Gasket area' : 'Material used';
      rows.push('<dt>' + areaLbl + '</dt><dd>' + (Math.round(q.breakdown.area * 10) / 10) + ' sq in</dd>');
      (q.warnings || []).forEach(function (w) { rows.push('<dt>Note</dt><dd>' + w + '</dd>'); });
      $('[data-gq-specs]').innerHTML = rows.join('');
    } else if (q.quoteOnly) {
      setText('[data-gq-total]', 'Quote'); setText('[data-gq-each]', 'over ' + q.instantLimit);
      setText('[data-gq-mtotal]', 'Quote'); setText('[data-gq-meach]', 'Request a quote below');
      $('[data-gq-save]').hidden = true;
      errs.hidden = true; errs.innerHTML = '';
      $('[data-gq-specs]').innerHTML = q.summary.slice(1).map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('') +
        '<dt>Quantity</dt><dd>' + q.qty + '</dd>';
    } else {
      setText('[data-gq-total]', '—'); setText('[data-gq-each]', '—'); setText('[data-gq-mtotal]', '—'); setText('[data-gq-meach]', 'Finish your specs');
      $('[data-gq-save]').hidden = true;
      $('[data-gq-specs]').innerHTML = '';
      errs.hidden = q.errors.length === 0;
      errs.innerHTML = q.errors.map(function (e) { return '<li>' + e + '</li>'; }).join('');
    }
    var qo = $('[data-gq-qo]');
    if (qo) {
      qo.hidden = !q.quoteOnly;
      if (q.quoteOnly) qo.innerHTML = '<strong>Instant prices go up to ' + esc(q.instantLimit) + '.</strong> ' + esc(q.quoteOnlyReason);
    }
    var sendable = q.ok || !!q.quoteOnly;
    $('[data-gq-add]').hidden = !endpoint || !!q.quoteOnly;
    $('[data-gq-add]').disabled = !q.ok;
    $('[data-gq-request-open]').hidden = !!endpoint && !q.quoteOnly;
    $('[data-gq-request-open]').disabled = !sendable;
    $('[data-gq-request-open]').innerHTML = (q.quoteOnly ? 'Request a quote' : 'Request this quote') + ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
    $('[data-gq-request-alt]').hidden = !endpoint || !q.ok;
    $('[data-gq-request-submit]').disabled = !sendable;
    store();
  }

  function quoteText(q) {
    var lines = ['CUSTOM GASKET QUOTE REQUEST', ''];
    q.summary.forEach(function (r) { lines.push(r[0] + ': ' + r[1]); });
    lines.push('Quantity: ' + q.qty);
    lines.push(q.quoteOnly ? 'Price: quote required (over ' + q.instantLimit + ' instant-price limit)' : 'Quoted price: ' + C.money(q.unitPrice, config) + ' each, ' + C.money(q.lineTotal, config) + ' total');
    if (state.notes) lines.push('', 'Notes: ' + state.notes);
    lines.push('', 'Quote ref: RD-' + C.fingerprint(currentSpec()));
    lines.push('Link: ' + location.href);
    return lines.join('\n');
  }

  function showMsg(html, kind) {
    $('[data-gq-msg]').innerHTML = html ? '<div class="notice ' + (kind || '') + '">' + html + '</div>' : '';
  }

  // ---------- add to cart ----------
  function addToCart() {
    var q = lastQuote;
    if (!q || !q.ok || !endpoint) return;
    var btn = $('[data-gq-add]');
    btn.disabled = true; var label = btn.innerHTML; btn.textContent = 'Adding…';
    showMsg('');
    var spec = currentSpec();
    fetch(endpoint + '/quote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ spec: spec, shop: (window.Shopify && Shopify.shop) || '' })
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        var j = res.body || {};
        if (!j.ok) throw new Error((j.errors && j.errors.join(' ')) || j.error || 'The checkout service could not price this gasket.');
        var props = {};
        q.summary.forEach(function (r) { props[r[0]] = r[1]; });
        if (state.notes) props['Notes'] = state.notes;
        props['Quote ref'] = j.quoteRef;
        props['_quoted_qty'] = String(q.qty);
        props['_spec'] = JSON.stringify(spec);
        return fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: j.variantId, quantity: q.qty, properties: props }] })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return j;
        });
      })
      .then(function (j) {
        if (window.RD && RD.refreshCartCount) RD.refreshCartCount();
        var note = Math.abs(j.unitPrice - q.unitPrice) > 0.004 ? ' Price updated to ' + C.money(j.unitPrice, config) + ' each.' : '';
        showMsg('Added to your cart.' + note + ' <a href="' + root.dataset.cartUrl + '" style="text-decoration:underline">View cart</a> · <a href="' + shopRoot + 'checkout" style="text-decoration:underline">Check out</a>', 'ok');
      })
      .catch(function (e) {
        showMsg((e && e.message ? e.message : 'Something went wrong.') + ' You can send this as a quote request instead.', 'err');
        $('[data-gq-request]').hidden = false;
      })
      .then(function () { btn.disabled = !(lastQuote && lastQuote.ok); btn.innerHTML = label; });
  }

  // ---------- file uploads + emailed requests ----------
  var preview = root.dataset.preview === 'true';
  var canUpload = !!endpoint || preview;
  var MAX_FILES = 10, MAX_TOTAL = 15 * 1024 * 1024;
  var OK_EXT = /\.(pdf|png|jpe?g|gif|webp|heic|tiff?|bmp|dxf|dwg|dwf|step|stp|igs|iges|sldprt|sldasm|slddrw|x_t|x_b|sat|stl|3mf|ipt|iam|idw|prt|catpart|f3d|ai|eps|svg|docx?|xlsx?|csv|txt|rtf|zip)$/i;
  var uploads = [];
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtSize(b) { return b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }
  function fileProblems(u) {
    var probs = [], total = 0, bad = [];
    u.files.forEach(function (f) { total += f.size; if (!OK_EXT.test(f.name)) bad.push(f.name); });
    if (bad.length) probs.push('These file types can\'t be sent: ' + bad.join(', ') + '. Send PDF, images, CAD (DXF, DWG, STEP, IGES, SolidWorks, STL), Word, Excel or ZIP.');
    if (u.files.length > MAX_FILES) probs.push('Attach up to ' + MAX_FILES + ' files.');
    if (total > MAX_TOTAL) probs.push('Files add up to ' + fmtSize(total) + '; the limit is 15 MB. Email larger files to ' + root.dataset.email + '.');
    return probs;
  }
  function renderFiles(u) {
    u.list.innerHTML = u.files.map(function (f, i) {
      var ok = OK_EXT.test(f.name);
      return '<li class="' + (ok ? '' : 'bad') + '"><span>' + esc(f.name) + '</span><small>' + (ok ? fmtSize(f.size) : 'type not accepted') + '</small><button type="button" data-rm="' + i + '" aria-label="Remove ' + esc(f.name) + '">Remove</button></li>';
    }).join('');
  }
  root.querySelectorAll('[data-gq-upload]').forEach(function (box) {
    var u = { box: box, files: [], input: box.querySelector('[data-gq-file-input]'), list: box.querySelector('[data-gq-file-list]'), required: box.hasAttribute('data-required') };
    uploads.push(u);
    var off = box.nextElementSibling;
    if (!canUpload) {
      box.hidden = true;
      if (off && off.hasAttribute('data-gq-upload-off')) off.hidden = false;
      return;
    }
    var add = function (list) { for (var i = 0; i < list.length; i++) u.files.push(list[i]); renderFiles(u); };
    u.input.addEventListener('change', function () { add(u.input.files); u.input.value = ''; });
    var drop = box.querySelector('[data-gq-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer) add(e.dataTransfer.files); });
    u.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rm]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      u.files.splice(+b.dataset.rm, 1); renderFiles(u);
    });
  });
  function uploadFor(form) { for (var i = 0; i < uploads.length; i++) if (form.contains(uploads[i].box)) return uploads[i]; return null; }
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }

  /** Sends a request (fields + files) to the service, which emails it to the store. */
  function sendRequest(form, fields) {
    var u = uploadFor(form);
    var probs = u ? fileProblems(u) : [];
    if (u && u.required && !u.files.length) probs.unshift('Attach at least one drawing, CAD file or photo.');
    if (probs.length) return Promise.reject(new Error(probs.join(' ')));
    var hp = form.querySelector('[data-gq-hp]');
    var fd = new FormData();
    Object.keys(fields).forEach(function (k) { if (fields[k] !== undefined && fields[k] !== null) fd.append(k, fields[k]); });
    fd.append('website', hp ? hp.value : '');
    fd.append('page', location.href);
    var files = u ? u.files.slice() : [];
    files.forEach(function (f) { fd.append('files', f, f.name); });
    if (preview) {
      return new Promise(function (resolve) { setTimeout(function () { resolve({ ok: true, preview: true, files: files.length }); }, 300); });
    }
    return fetch(endpoint + '/request', { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) {
        if (!j.ok) throw new Error((j.errors && j.errors.join(' ')) || j.error || 'Your request could not be sent.');
        if (u) { u.files = []; renderFiles(u); }
        return j;
      });
  }
  function doneHtml(j, email, what) {
    if (j.preview) {
      return '<div class="gq-done"><strong>Preview only.</strong> On your store this emails the ' + what + (j.files ? ' and ' + j.files + ' file' + (j.files > 1 ? 's' : '') : '') + ' to ' + esc(root.dataset.email) + '. Nothing was sent.</div>';
    }
    return '<div class="gq-done"><strong>Sent.</strong> We\'ll reply to ' + esc(email) + ' with price and lead time, usually the same business day.' + (j.ref ? ' Reference ' + esc(j.ref) + '.' : '') + '</div>';
  }
  function failHtml(e) {
    return '<div class="notice err">' + esc(e && e.message ? e.message : 'Your request could not be sent.') + ' You can also email <a href="mailto:' + esc(root.dataset.email) + '" style="text-decoration:underline">' + esc(root.dataset.email) + '</a> or call ' + esc(root.dataset.phone) + '.</div>';
  }

  // Drawing / CAD request form
  var dwg = document.getElementById('GasketDrawingRequest');
  if (dwg) {
    var dsel = dwg.querySelector('[data-gd-material]');
    if (dsel) {
      var names = config.materials.map(function (m) { return m.name; }).concat((config._hidden_materials || []).map(function (m) { return m.name; }));
      dsel.innerHTML = '<option value="">Choose a material (optional)</option>' + names.map(function (n) { return '<option>' + esc(n) + '</option>'; }).join('') + '<option>Other / not sure</option>';
    }
    dwg.addEventListener('submit', function (e) {
      if (!canUpload) return; // Shopify contact form handles it (no attachments)
      e.preventDefault();
      var btn = dwg.querySelector('[data-gd-submit]'), msg = dwg.querySelector('[data-gd-msg]');
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Sending…'; msg.innerHTML = '';
      sendRequest(dwg, {
        kind: 'drawing', name: val('gd-name'), company: val('gd-company'), email: val('gd-email'), phone: val('gd-phone'),
        material: val('gd-material'), thickness: val('gd-thickness'), qty: val('gd-qty'), needed_by: val('gd-needed'), notes: val('gd-notes')
      }).then(function (j) {
        msg.innerHTML = doneHtml(j, val('gd-email'), 'request');
        if (!j.preview) dwg.reset();
      }).catch(function (err) { msg.innerHTML = failHtml(err); })
        .then(function () { btn.disabled = false; btn.innerHTML = label; });
    });
  }

  // ---------- events ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
    if (t.dataset.shape) {
      if (t.dataset.shape === state.shape) return;
      var sameFamily = !!ROUND[state.shape] === !!ROUND[t.dataset.shape];
      state.shape = t.dataset.shape;
      // keep values for shared fields (od/id/w/l...), fill the rest with defaults;
      // hole settings only carry over within round shapes or within rectangles
      var def = loadDefaults(state.shape), keep = {};
      C.SHAPES[state.shape].fields.forEach(function (k) {
        var carry = sameFamily || (k !== 'holes' && k !== 'hole_d');
        keep[k] = carry && state.dims[k] !== undefined && state.dims[k] !== '' ? state.dims[k] : def[k];
      });
      state.dims = keep;
      // shared sizes that don't fit the new shape (e.g. an opening bigger than the outside) -> start from defaults
      if (C.validate(state.shape, C.normalizeDims(state.shape, keep, state.units), config, state.units).length) state.dims = def;
      renderShapes(); renderFields(); update();
    } else if (t.dataset.unit) {
      if (t.dataset.unit === state.units) return;
      var to = t.dataset.unit;
      Object.keys(state.dims).forEach(function (k) {
        if (k === 'holes') return;
        var v = C.num(state.dims[k]);
        if (!isNaN(v)) state.dims[k] = fmtNum(to === 'mm' ? v * MM : v / MM, to);
      });
      state.units = to;
      renderUnits(); renderFields(); update();
    } else if (t.dataset.thick) {
      state.thickness = t.dataset.thick; renderMaterialDetail(); update();
    } else if (t.dataset.gqQtyStep) {
      var n = Math.max(1, (parseInt(state.qty, 10) || 1) + parseInt(t.dataset.gqQtyStep, 10));
      state.qty = String(n); $('[data-gq-qty]').value = state.qty; update();
    } else if (t.hasAttribute('data-gq-add')) {
      addToCart();
    } else if (t.hasAttribute('data-gq-request-open') || t.hasAttribute('data-gq-request-alt')) {
      $('[data-gq-request]').hidden = false;
      var em = document.getElementById('gq-email'); if (em) em.focus();
    } else if (t.hasAttribute('data-gq-copy')) {
      store();
      var url = location.href;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
        .then(function () { showMsg('Link copied — anyone with it can open this exact quote.', 'ok'); })
        .catch(function () { window.prompt('Copy this link:', url); });
    }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset.dim) {
      state.dims[t.dataset.dim] = t.value;
      if (t.dataset.dim === 'holes') {
        var off = rectHolesOff();
        root.querySelectorAll('[data-field="hole_d"], [data-field="e"]').forEach(function (el) { if (isRectShape(state.shape)) el.hidden = off; });
      }
      update();
    }
    else if (t.hasAttribute('data-gq-qty')) { state.qty = t.value.replace(/[^\d]/g, '') || ''; update(); }
    else if (t.hasAttribute('data-gq-notes')) { state.notes = t.value; }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-gq-material')) { state.material = t.value; renderMaterialDetail(); update(); }
    else if (t.hasAttribute('data-gq-psa')) { state.psa = t.checked; update(); }
  });
  var form = document.getElementById('GasketQuoteRequest');
  if (form) form.addEventListener('submit', function (e) {
    var panel = $('[data-gq-request]');
    if (panel.hidden || !lastQuote || !(lastQuote.ok || lastQuote.quoteOnly)) { e.preventDefault(); return; }
    $('[data-gq-body]').value = quoteText(lastQuote);
    $('[data-gq-subject]').value = 'Gasket quote RD-' + C.fingerprint(currentSpec()) + ' — ' + (lastQuote.quoteOnly ? 'large part, quote required' : C.money(lastQuote.lineTotal, config));
    store();
    if (!canUpload) return; // Shopify contact form handles it (no attachments)
    e.preventDefault();
    var btn = $('[data-gq-request-submit]'), msg = $('[data-gq-req-msg]');
    var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Sending…'; msg.innerHTML = '';
    var q = lastQuote;
    sendRequest(form, {
      kind: 'quote', name: val('gq-name'), company: val('gq-company'), email: val('gq-email'), phone: val('gq-phone'),
      notes: state.notes, spec: JSON.stringify(currentSpec()), quote_text: quoteText(q),
      unit_price: q.ok ? String(q.unitPrice) : '', line_total: q.ok ? String(q.lineTotal) : ''
    }).then(function (j) { msg.innerHTML = doneHtml(j, val('gq-email'), 'quote'); })
      .catch(function (err) { msg.innerHTML = failHtml(err); })
      .then(function () { btn.disabled = !(lastQuote && (lastQuote.ok || lastQuote.quoteOnly)); btn.innerHTML = label; });
  });
  var mgo = $('[data-gq-mgo]');
  if (mgo) mgo.addEventListener('click', function (e) {
    e.preventDefault();
    document.getElementById('GasketQuoter-price').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---------- init ----------
  if (config.sample_pricing) $('[data-gq-sample]').hidden = false;
  var restored = false;
  var m = location.hash.match(/[#&]q=([A-Za-z0-9_-]+)/);
  if (m) restored = decodeState(m[1]);
  if (!restored) { try { var ss = sessionStorage.getItem('rd-gq'); if (ss && /contact_posted/.test(location.search)) restored = decodeState(ss); } catch (e) {} }
  if (!restored || !Object.keys(state.dims).length) state.dims = loadDefaults(state.shape);
  renderShapes(); renderUnits(); renderFields(); renderMaterials(); renderMaterialDetail(); renderPsa();
  $('[data-gq-qty]').value = state.qty;
  update();
})();
